<template>
  <az-formbar>
    <div class="show header-pregao">
      <div class="itens">
        <div class="item pl-2">
          <label>Processo</label>
          <span>{{licitacao.numProcesso || '-'}}</span>
          <br>
          <span v-if="licitacao.numRepeticao > 0">
            <strong>Repetição:</strong> {{licitacao.numRepeticao || '-'}}
          </span>
        </div>
        <div class="item">
          <label>Edital</label>
          <span>{{licitacao.numeroEdital || '-'}}</span>
        </div>
        <div class="item">
          <label>Fim Envio de Propostas</label>
          <span>{{licitacao.dataFimEnvioProposta | az-date('DD/MM/YYYY HH:mm')}}</span>
        </div>
        <div class="item">
          <label>Abertura da Licitação</label>
          <span>{{licitacao.dataAbertura | az-date('DD/MM/YYYY HH:mm')}}</span>
        </div>
        <div class="item" v-if="licitacao.modoDisputa == 'ABERTO_FECHADO'">
          <label>Tempo da Fase Aberto/Fechado</label>
          <span>{{licitacao.tempoFaseAbertoFechado || '-'}} min.</span>
        </div>
      </div>
      <div class="actions">
        <div>
            <az-call-to-action dark :active="true" :outline="true"
                               @click="acessarLicitacao" class="no-mobile">
                ACESSAR
            </az-call-to-action>
        </div>
      </div>
    </div>
  </az-formbar>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'LicitacaoVisualizacaoAcoes',
    components: {
    },
    computed: {
        ...mapState(['licitacao'])
    },
    methods:{
        async acessarLicitacao(){
            const licitacaoId = this.licitacao.id
            const urlExecucao = `licitacao/#/licitacoes/${licitacaoId}/proposta/dadosGerais`
            const url = `${window.location.protocol}//${window.location.hostname}/${urlExecucao}`
            window.open(url, '_blank')
        }
    }
}
</script>

<style scoped lang="stylus">
.header-pregao
  padding 5px

.az-form-bar
  border-top-left-radius 5px !important
  border-top-right-radius 5px !important

.item
  display: flex
  label
    font-weight bold
.item-right
  color white
  display flex
  flex-direction column
  label
    font-size 12px
    font-weight bold

.btn-cancelar-envio-proposta
  display flex !important
  flex-direction column
  justify-content center
  margin-right 0 !important

.item
  margin-right 25px !important

.az-form-bar
  .show
    min-height 70px !important
    height auto !important
</style>
